// airtable free database
const API_BASE_PATH = 'https://api.airtable.com/v0/app0twXIbmE3jPd9w/';
const API_TOKEN = 'patE8UGXJV1vzFVjE.33b70212f9cdc9ae65b6cf9594062d0135b10537f6400a471bdeb3f272ea3227';

const API =	{
	// to get experience data from airtable
	async getExperience(){
		var myHeaders = new Headers();
		myHeaders.append("Authorization", "Bearer "+API_TOKEN);

		var requestOptions = {
			method: 'GET',
			headers: myHeaders,
			redirect: 'follow'
		};

		return fetch(API_BASE_PATH+"Experience?view=Grid%20view&sort%5B0%5D%5Bfield%5D=index&sort%5B0%5D%5Bdirection%5D=asc", requestOptions)
		.then(response => response.json())
		.then((result) => {
			return result
		})
		.catch(error => console.log('error', error));
	},

	// to get expertise data from airtable
	async getExpertise(){
		var myHeaders = new Headers();
		myHeaders.append("Authorization", "Bearer "+API_TOKEN);

		var requestOptions = {
			method: 'GET',
			headers: myHeaders,
			redirect: 'follow'
		};

		try {
			const response = await fetch(API_BASE_PATH + "Expertise?view=Grid%20view&sort%5B0%5D%5Bfield%5D=index&sort%5B0%5D%5Bdirection%5D=asc", requestOptions);
			const result_1 = await response.json();
			return result_1;
		} catch (error) {
			return console.log('error', error);
		}
	},

	// to get Education data from airtable
	async getEducation(){
		var myHeaders = new Headers();
		myHeaders.append("Authorization", "Bearer "+API_TOKEN);

		var requestOptions = {
			method: 'GET',
			headers: myHeaders,
			redirect: 'follow'
		};

		try {
			const response = await fetch(API_BASE_PATH + "Education?view=Grid%20view&sort%5B0%5D%5Bfield%5D=index&sort%5B0%5D%5Bdirection%5D=asc", requestOptions);
			const result_1 = await response.json();
			return result_1;
		} catch (error) {
			return console.log('error', error);
		}
	},

	// to get Portfolio data from airtable
	async getPortfolio(){
		var myHeaders = new Headers();
		myHeaders.append("Authorization", "Bearer "+API_TOKEN);

		var requestOptions = {
			method: 'GET',
			headers: myHeaders,
			redirect: 'follow'
		};

		return fetch(API_BASE_PATH+"Portfolio?view=Grid%20view&sort%5B0%5D%5Bfield%5D=index&sort%5B0%5D%5Bdirection%5D=asc", requestOptions)
		.then(response => response.json())
		.then((result) => {
			return result
		})
		.catch(error => console.log('error', error));
	},
}

export default API;